export default "__VITE_ASSET__YhkRIfqn__"